import type { Stat } from '@/types/impact'

export const stats: Stat[] = [
  { value: 500, suffix: '+', label: 'Entrepreneurs Supported' },
  { value: 2000, suffix: '+', label: 'Young People Engaged' },
  { value: 150, suffix: '+', label: 'Women Trained & Mentored' },
  { value: 25, suffix: '+', label: 'Communities Reached' },
  { value: 40, suffix: '+', label: 'Strategic Partnerships Established' },
  { value: 30, suffix: '+', label: 'Programmes and Events Delivered' },
]
